import C from "@/c";

const state = {
  // init
  // mode: "LOADING",
  // status: "LOADING",
  // history: [],

  // user data
  userDoc: C.USER,
  userLabel: "", // user initial
  // app data
  orderDoc: C.MANUFACTURING_ORDER,
  purchasingOrderDoc: C.PURCHASING_ORDER,
  inventoryDoc: C.INVENTORY_ITEM,
};
const getters = {
  getUserLabel: (state) => {
    return state.userLabel;
  },
  getUser: (state) => {
    // console.log("store GET userDoc");
    return state.userDoc;
  },
  getOrder: (state) => {
    return state.orderDoc;
  },
  getPurchasingOrder: (state) => {
    return state.purchasingOrderDoc;
  },
  getInventoryItem: (state) => {
    return state.inventoryDoc;
  },
  isAdmin: (state) => {
    return state.userDoc.user_type == C.USER_TYPE.ADMIN;
  },
  isSuperUser: (state) => {
    return state.userDoc.user_type == C.USER_TYPE.SUPER_USER;
  },
  isManufacturer: (state) => {
    return state.userDoc.user_type == C.USER_TYPE.MANUFACTURER;
  },
  isPolisher: (state) => {
    return state.userDoc.user_type == C.USER_TYPE.POLISHER;
  },
  isWatchmaker: (state) => {
    return state.userDoc.user_type == C.USER_TYPE.WATCHMAKER;
  },
};
const mutations = {
  // user data
  setUser(state, userDoc) {
    // console.log("store SET userDoc");
    if (!userDoc) {
      state.userLabel = "";
      state.userDoc = C.USER;
      return;
    }
    state.userLabel = userDoc.username.charAt(0);
    state.userDoc = userDoc;
  },
  // app data
  setOrder(state, orderDoc) {
    // console.log("store SET watchDoc");
    state.orderDoc = orderDoc;
  },
  setPurchasingOrder(state, doc) {
    // console.log("store SET serviceDoc");
    state.purchasingOrderDoc = doc;
  },
  setInventoryItem(state, doc) {
    // console.log("store SET serviceDoc");
    state.inventoryDoc = doc;
  },
};

export default {
  state,
  getters,
  mutations,
};
